import React from 'react'
import {
    H5,
    Row,
    Col,
    Card,
    Button,
    FormikInput,
    FormikSelect,
    FormikTextArea,
    FormikCheckbox,
    FormRadioGroup,
    CollapsableCard,
    FormikPhoneMaskedInput,
} from '../../../Elements'
import { Icon, MenuItem } from '@blueprintjs/core'
import { envShowCentralTexas } from '../../../utils/helpers';


const cardStyle = {
    minWidth: 300
}

const mapIconStyleValid = {
    color: 'green'
}

const homeownerOptions = [{
    id: 1,
    name: 'Company'
},
{
    id: 2,
    name: 'Homeowner'
}]

const homeOwnerId = envShowCentralTexas ? '386' : '0'


export default ({ values, dirty, customers, supervisors, homeowners, onCheckAddressClicked, estimates, loadingBaseJob, ...props }) => {
    const companyIsOthers = values?.company?.id?.toString() === homeOwnerId
    const supervisorList = companyIsOthers ? homeowners : supervisors

    const company_id = values?.company?.id

    customers = customers.map(c => ({
        id: c.id,
        name: c.company_name,
        is_active: c.is_active
    })).sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)

    const customSupervisorOnChangeCalc = (rawThisName, thisNewVal, _) => {
        const rawPhoneNumber = thisNewVal.phone_number
        if (!rawPhoneNumber) {
            return ''
        }
        const cleaned = ('' + rawPhoneNumber).replace(/\D/g, '')

        return cleaned.length < 4
            ? cleaned
            : cleaned.length < 7
                ? '(' + cleaned.slice(0, 3) + ') ' + cleaned.slice(3, cleaned.length)
                : '(' + cleaned.slice(0, 3) + ') ' + cleaned.slice(3, 6) + '-' + cleaned.slice(6, cleaned.length)
    }
    return (
        <Row>
            <Col lg={4} className={loadingBaseJob ? 'bp3-skeleton' : ''}>
                <Card style={cardStyle}>
                    <H5>Company Information</H5>

                    <FormRadioGroup
                        items={homeownerOptions}
                        value={companyIsOthers ? homeownerOptions[1] : homeownerOptions[0]}
                        onChange={(evt) => {
                            props.setFieldValue('phone', null)
                            if (evt.currentTarget.value === "2") {
                                const c = customers.find(c => c.id.toString() === homeOwnerId)
                                props.setFieldValue('company', c)
                            } else {
                                props.setFieldValue('company', null)
                            }
                        }
                        }
                    />

                    {!companyIsOthers && <FormikSelect
                        nullable
                        name='company'
                        label='Company'
                        items={customers.filter(c => c.is_active || c.id === company_id)}
                        label_property={'company_name'}
                        disableMaxListSize
                        listenerComponents={[
                            { componentName: `company_supervisor`, componentNewValueCalculator: (a, b, c) => null },
                            { componentName: `phone`, componentNewValueCalculator: (a, b, c) => null }
                        ]}
                    />}
                    <FormikSelect
                        nullable
                        name='company_supervisor'
                        label={companyIsOthers ? 'Homeowner' : 'Company Supervisor'}
                        items={supervisorList}
                        listenerComponents={[{ componentName: `phone`, componentNewValueCalculator: (a, b, c) => customSupervisorOnChangeCalc(a, b, c) }]}
                        disableMaxListSize
                    />
                    <FormikPhoneMaskedInput
                        name='phone'
                        label='Phone'
                        placeholder='phone...'
                    />
                    <FormikTextArea
                        name='notes'
                        label='Notes'
                        key={`notes-${values?.notes}`}
                    />
                    {envShowCentralTexas &&
                        <FormikCheckbox
                            name='is_central_texas'
                            label='Central'
                            checked={values?.is_central_texas}
                        />
                    }
                </Card>
            </Col>
            <Col lg={4} className={loadingBaseJob ? 'bp3-skeleton' : ''}>
                <Card style={cardStyle}>
                    <H5>Job Information</H5>
                    <FormikInput
                        name="name"
                        key={`job_name-${values?.name}`}
                        label="Job Name"
                        placeholder="Job Name..."
                    />
                    <FormikInput
                        name="address_line_1"
                        label="Line 1"
                        key={`address_line_1-${values?.address_line_1}`}
                        placeholder="1234 Example Ln"
                        rightElement={<Button
                            minimal
                            icon={
                                <>
                                    <Icon
                                        icon="map-marker"
                                        style={values?.isValidAddress ? mapIconStyleValid : {}}
                                    />
                                    {values?.isValidAddress && <Icon
                                        icon="tick"
                                        style={mapIconStyleValid}
                                    />}
                                </>
                            }
                            onClick={evt => onCheckAddressClicked(true)}
                        />}
                    />
                    <FormikInput
                        name="address_line_2"
                        label="Line 2"
                        placeholder="Apt/Unit 42"
                        key={`address_line_2-${values?.address_line_2}`}
                    />
                    <FormikInput
                        name="city"
                        label="City"
                        placeholder="City..."
                        key={`city-${values?.city}`}
                    />
                    <FormikInput
                        name="state"
                        label="State"
                        placeholder="State..."
                        key={`state-${values?.state}`}
                    />
                    <FormikInput
                        name="zip_code"
                        label="Zip Code"
                        placeholder="....."
                        key={`zip_code-${values?.zip_code}`}
                    />
                    <FormikInput
                        name="county"
                        label="County"
                        placeholder="County..."
                        key={`county-${values?.county}`}
                    />
                </Card>
            </Col>
            <Col lg={4} className={loadingBaseJob ? 'bp3-skeleton' : ''}>
                <Card style={cardStyle}>
                    <H5>Additional Site Information</H5>
                    <FormikInput
                        name="key_map"
                        label="Key Map"
                        placeholder="xyzyx"
                        key={`key_map-${values?.key_map}`}
                    />
                    <FormikInput
                        name="mmg_mileage"
                        label="From MMG"
                        placeholder="..."
                        key={`mmg_mileage-${values?.mmg_mileage}`}
                    />
                    {values?.is_central_texas &&
                        <FormikInput
                            name="manchaca_mileage"
                            label="From Manchaca"
                            placeholder='...'
                            key={`manchaca_mileage-${values?.manchaca_mileage}`}
                        />
                    }
                    <FormikInput
                        name="gate_code"
                        label="Gate Code"
                        placeholder="...."
                        key={`gate_code-${values?.gate_code}`}
                    />
                    <FormikCheckbox
                        name='is_display'
                        label='Display'
                        checked={values?.is_display}
                    />
                    <FormikCheckbox
                        name='is_commercial'
                        label='Commercial'
                        checked={values?.is_commercial}
                    />
                </Card>
                {values?.id && !values?.is_estimate && !values?.was_estimated &&
                    <CollapsableCard title='Merge An Existing Estimate' style={cardStyle} defaultAsClosed>
                        <FormikSelect
                            nullable
                            name='estimate_to_merge'
                            label='Estimate To Merge'
                            items={estimates}
                            customItemRenderer={(item, { handleClick, modifiers }) => (
                                <MenuItem
                                    active={modifiers.active}
                                    key={item.id}
                                    text={item.name}
                                    labelElement={item.id && <Icon icon='eye-open' iconSize='15' intent='primary' style={{ cursor: 'pointer' }} onClick={() => window.open(`/estimate/${item.id}/edit`, '_blank')} />}
                                    onClick={(e) => handleClick(item, e)}
                                />
                            )}
                        />
                    </CollapsableCard>
                }
            </Col>
        </Row >
    )
}